import { useTrackingHelper } from './hooks';

const TrackingContainer = ({ children }: { children: React.ReactNode }) => {
  useTrackingHelper();
  return <>{children}</>;
};

export default TrackingContainer;
